import React,{Component} from 'react';
import {withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import Label from '@react/react-spectrum/Label';
import {Grid,GridRow,GridColumn} from '@react/react-spectrum/Grid';
import Moment from 'react-moment';
import * as appConstants from '../../constants/AppConstants';
import {getApprovalHeaderInfo} from '../../models/ApprovalHeaderDto';
import FlexiblePromoBanner from "../Banner/FlexiblePromoBanner";
import I2TBanner from '../Banner/I2TBanner';
import {connect} from "react-redux";




export class ApprovalHeader extends Component{

    render(){
        let badage = '';
        let initiatedByValues = "";
        let headerInfo = {};
        if(this.props.approvalObj.status.toUpperCase() === appConstants.APPROVE){
            badage =  <Label className="status-label-element" id="green" variant="green">{i18n.t(this.props.workFlowId+'.approvalDetails.headerInfo.status.APPROVED')}</Label>;
        }else if(this.props.approvalObj.status.toUpperCase() === appConstants.PENDING){
            badage = <Label className="status-label-element" id="orange" variant="or">{i18n.t(this.props.workFlowId+'.approvalDetails.headerInfo.status.PENDING')}</Label>;
        }else if(this.props.approvalObj.status.toUpperCase() === appConstants.REJECT){
            badage = <Label className="status-label-element" id="red" variant="red">{i18n.t(this.props.workFlowId+'.approvalDetails.headerInfo.status.REJECTED')}</Label>;
        }else if(this.props.approvalObj.status.toUpperCase() === appConstants.INPROGRESS){
            badage = <Label className="status-label-element" id="blue" variant="blue">{i18n.t(this.props.workFlowId+'.approvalDetails.headerInfo.status.IN_PROGRESS')}</Label>;
        }else if(this.props.approvalObj.status.toUpperCase() === appConstants.CANCEL){
            badage = <Label className="status-label-element" id="grey" variant="grey">{i18n.t(this.props.workFlowId+'.approvalDetails.headerInfo.status.CANCEL')}</Label>;
        }

        if(this.props.approvalObj && this.props.approvalObj.approvalMetaData.initiatorDetails ) {
            if(this.props.locale === 'ja' && this.props.approvalObj.approvalMetaData.initiatorDetails.firstName && this.props.approvalObj.approvalMetaData.initiatorDetails.lastName){
                initiatedByValues = <span id="header-value">{this.props.approvalObj.approvalMetaData.initiatorDetails.isSupportProfile ? `${this.props.approvalObj.approvalMetaData.initiatorDetails.firstName}` : `${this.props.approvalObj.approvalMetaData.initiatorDetails.lastName} ${this.props.approvalObj.approvalMetaData.initiatorDetails.firstName}`}</span>
            }          
            else if( this.props.locale !== 'ja' && this.props.approvalObj.approvalMetaData.initiatorDetails.firstName && this.props.approvalObj.approvalMetaData.initiatorDetails.lastName ) {
                initiatedByValues = <span id="header-value">{this.props.approvalObj.approvalMetaData.initiatorDetails.isSupportProfile ? `${this.props.approvalObj.approvalMetaData.initiatorDetails.firstName}` : `${this.props.approvalObj.approvalMetaData.initiatorDetails.firstName} ${this.props.approvalObj.approvalMetaData.initiatorDetails.lastName}`}</span>
            }
            else{
                initiatedByValues = <span id="header-value">{this.props.approvalObj.initiatorId}</span>
            }
        }        
        else{
            initiatedByValues = <span id="header-value">{this.props.approvalObj.initiatorId}</span>
        }

        let isEnableI2tBanner =  (this.props.approvalObj && this.props.approvalObj.approvalMetaData && this.props.approvalObj.approvalMetaData.i2tBannerDetails && this.props.approvalObj.approvalMetaData.i2tBannerDetails.currency) ? true  :false;
        let isI2TFeatureEnabled = (this.props.featureFlags.indexOf(appConstants.ENABLE_I2T_BANNER) > -1);

        let isEnableFpBanner = this.props.approvalObj && this.props.approvalObj.approvalMetaData && this.props.approvalObj.approvalMetaData.fpBannerDetails && this.props.approvalObj.approvalMetaData.fpBannerDetails.currency ? true : false;
        let isFpFeatureEnabled = this.props.featureFlags.indexOf(appConstants.ENABLE_FP_BANNER) > -1;

        headerInfo = getApprovalHeaderInfo(this.props.workFlowId,this.props.approvalObj);

        return(
            <Grid>
                <GridRow className="accordian-header" id="accordian-header-id">

                    <GridColumn className="align-center" data-am-id="approvalHeaderTeamInfo">
                        <p>
                            <strong>{i18n.t(headerInfo.team.key)}</strong>
                            <span className="header-value"> &gt; {headerInfo.team.value}</span>
                        </p>
                    </GridColumn>


                    <GridColumn className="align-center" data-am-id="approvalHeaderInitiatorInfo">
                    <p>
                        <strong>{i18n.t(headerInfo.initiatedBy.key)}</strong>
                        <span className="header-value"> &gt; {initiatedByValues}</span>
                    </p>
                    </GridColumn>

                <GridColumn className="align-center" data-am-id="approvalHeaderCreatedAt">
                    <p style={{padding: '0px 15px'}}>
                        <strong>{i18n.t(headerInfo.createdOn.key)}</strong>
                        <span className="header-value"> &gt;
                            <Moment format="LL" date={headerInfo.createdOn.value} locale={this.props.i18n.language}/>
                        </span>
                    </p>
                </GridColumn>

                <GridColumn className="align-center" data-am-id="approvalHeaderLastModifiedOn">
                    <p>
                        <strong>{i18n.t(headerInfo.approvalId.key)}</strong>
                        <span className="header-value"> &gt; {headerInfo.approvalId.value}</span>
                    </p>
                    </GridColumn>

                    <GridColumn  className="status-label align-center" data-am-id="approvalHeaderStatus">
                        {badage}
                    </GridColumn>
                </GridRow>
                {(isEnableI2tBanner && isI2TFeatureEnabled) ? (
                     <GridRow>
                         <GridColumn className="align-center" data-am-id="approvalHeaderInitiatorInfo">
                            <I2TBanner workFlowId={this.props.workFlowId} bannerDetails={this.props.approvalObj.approvalMetaData.i2tBannerDetails} date={this.props.approvalObj.createdAt} locale={this.props.i18n.language}/>
                        </GridColumn>
                    </GridRow>
                    ) :''}
                {isEnableFpBanner && isFpFeatureEnabled ? (
                  <GridRow>
                    <GridColumn className="align-center" data-am-id="approvalHeaderInitiatorInfo">
                      <FlexiblePromoBanner
                        workFlowId={this.props.workFlowId}
                        bannerDetails={this.props.approvalObj.approvalMetaData.fpBannerDetails}
                        locale={this.props.i18n.language}
                      />
                    </GridColumn>
                  </GridRow>
                ) : (
                  ""
                )}
    
            </Grid>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        featureFlags: state.AppReducer.featureFlags
    }
};


export default connect(mapStateToProps)(withTranslation()(ApprovalHeader));

